// extracted by mini-css-extract-plugin
export default {"root":"qhEMWuGR6zRJE7imbYjO","wrap":"LIo0VHfgrDYZaTtloBRY","main":"TFWYvhRNilqSOQ1p2aig"};